import type { IAssessmentSlot } from '../types';

const slots: IAssessmentSlot[] = [
  { index: 1, renderer: 'choice', skill: 'grammar' },
  { index: 2, renderer: 'choice', skill: 'meaning' },
  { index: 3, renderer: 'audio_choice', skill: 'listening' },
  { index: 4, renderer: 'reorder', skill: 'grammar' },
  { index: 5, renderer: 'choice', skill: 'meaning' },
  { index: 6, renderer: 'video_choice', skill: 'listening' },
  { index: 7, renderer: 'typed_cloze', skill: 'grammar' },
  { index: 8, renderer: 'choice', skill: 'meaning' },
  { index: 9, renderer: 'audio_choice', skill: 'listening' },
  { index: 10, renderer: 'choice', skill: 'grammar' },
  { index: 11, renderer: 'choice', skill: 'meaning' },
  { index: 12, renderer: 'audio_choice', skill: 'listening' },
];

export const ASSESSMENT_BENCHMARK_SLOT_PLAN: readonly Readonly<IAssessmentSlot>[] = Object.freeze(
  slots.map((slot) => Object.freeze(slot)),
);
